import { MainContainer } from "../../component/container";
import news from '../../assets/image/news.jpg'
import BouncingIcon from "../../component/BouncingIcon";
import Nw1 from '../../assets/image/nw1.jpg'
import Nw2 from '../../assets/image/nw2.jpg'
import Nw3 from '../../assets/image/nw3.jpg'
import Banner from '../../assets/image/sp1.gif'
import { Element, Link } from 'react-scroll';
// import UploadPhoto from "../../component/UploadPhoto";
import { useEffect, useState } from "react";
// import axios from "axios";

export default function News() {
    // const queryString = window.location.search;
    // const isModMode = queryString.includes('?mod');
    // const url = process.env.REACT_APP_URL;
    // const [data, setData] = useState([]);
    const [refresh, setRefresh] = useState(true)

    useEffect(() => {
        const fetchData = async () => {
            try {
                // const response = await axios.get(url + '/get');
                // setData(response.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        if (refresh) {
            fetchData();
            setRefresh(false)
        }
        // eslint-disable-next-line
    }, [refresh]);

    const Section = ({ title, Img, Detail }) => {
        return (
            <div className="flex flex-col items-center gap-3">
                <label className="font-bold w-full text-xl text-[#2E51A9]">{title}</label>
                <div className="flex items-center justify-between gap-4 w-full">
                    {Img && !Img.includes('mkv') && !Img.includes('mp4') ?
                        <img src={Img} alt={title} className='w-[500px]' />
                        :
                        // <video src={Img} autoPlay alt={title} className='w-[500px]' />
                        Img !== null &&
                        <video className="w-[500px]" autoPlay controls playsInline loop muted>
                            <source src={Img} type="video/mp4" />
                        </video>
                    }
                    <span className="lg:flex hidden w-full">{Detail ? Detail : ''}</span>
                </div>
                <span className="lg:hidden flex text-center" >{Detail ? Detail : ''}</span>
            </div>
        )
    }

    return (
        <MainContainer>
            <div id='content' className="">
                <img src={news} alt="News" className='w-screen h-screen object-cover opacity-70' />

                <div className="w-full absolute top-1/2 left-0 transform -translate-y-1/2 2xl:px-80 xl:px-52 px-10">
                    <div className="bg-[#87ceeb] bg-opacity-70 p-4 rounded-full">
                        <h1 className="text-lg sm:text-4xl font-bold text-white text-center">
                            What's New.
                        </h1>
                    </div>
                </div>


                <Link to="Scroll" smooth={true} duration={500}>
                    <BouncingIcon />
                </Link>
            </div>
            <Element name="Scroll" className="element"><div className='min-h-[2px]'></div></Element>s

            <div className="2xl:px-80 xl:px-52 px-10 mt-24  flex flex-col gap-24">
                <Section title={`Visit of the Congolese ambassador of peace to JHS, Miami, Florida`} Img={Nw1} Detail={""} />
                <Section title={`Visit of the ACRFI Founder to ACRFI Congo`} Img={Nw2} Detail={""} />
                <Section title={`Visit of the ACRFI Co-Founder to ACRFI Katanga`} Img={Nw3} Detail={""} />


                <img src={Banner} alt={'Banner'} className='' />

                {/* {Array.isArray(data) && data.length > 0 ? (
                    data.map((item) => (
                        <div key={item.filename} className="image-item">
                            <Section title={item.title} Img={item.filename ? `${url}/uploads/${item.filename}` : null} Detail={item.message} />
                        </div>
                    ))
                ) : null}


                {isModMode &&
                    <div>
                        <span className=" text-xl font-bold text-[#2E51A9] ">ADD NEWS</span>
                        <UploadPhoto setRefresh={setRefresh} />
                    </div>
                } */}
            </div>
        </MainContainer>
    )
}